/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { devicesRouterOffblack } from "../assets/devices-router-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconDevicesRouterOffblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={devicesRouterOffblack.svg} />
);

IllustrativeIconDevicesRouterOffblack.displayName = "IllustrativeIconDevicesRouterOffblack";
